export const ACTION_RESET = 'FETCH_VIDEO_DETAIL_RESET';
export const ACTION_REQUEST = 'FETCH_VIDEO_DETAIL_REQUEST';
export const ACTION_SUCCESS = 'FETCH_VIDEO_DETAIL_SUCCESS';
export const ACTION_ERROR = 'FETCH_VIDEO_DETAIL_ERROR';
